(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-browse]');
    if (!link) return;
    const catalog = document.querySelector('sfs-catalog');
    if (catalog && typeof catalog.filter === 'function') catalog.filter(link.dataset.browse);
  });
  const openPolicy = () => {
    if (!['#sfs-shipping', '#sfs-guarantee'].includes(location.hash)) return;
    const panel = document.querySelector(location.hash);
    if (panel?.tagName === 'DETAILS') panel.open = true;
  };
  window.addEventListener('hashchange', openPolicy);
  openPolicy();
  if (!customElements.get('sfs-announcements')) {
    class SfsAnnouncements extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        const group = this.querySelector('.sfs-ticker-group');
        const setPace = () => {
          const pixelsPerSecond = 280 / ((Number(this.dataset.delay) || 7000) / 1000);
          this.style.setProperty('--sfs-ticker-duration', `${group.getBoundingClientRect().width / pixelsPerSecond}s`);
        };
        this.paceObserver = new ResizeObserver(setPace);
        this.paceObserver.observe(group);
        setPace();
        this.querySelector('[data-pause]').hidden = false;
        this.querySelector('[data-pause]').addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateControl();
        }, options);
        this.motion.addEventListener('change', event => {
          this.paused = event.matches || this.dataset.autoplay !== 'true';
          this.updateControl();
        }, options);
        this.updateControl();
      }
      updateControl() {
        this.classList.toggle('is-paused', this.paused);
        this.querySelector('[data-pause]').setAttribute('aria-label', this.paused ? 'Play announcements' : 'Pause announcements');
        this.querySelector('[data-pause-label]').textContent = this.paused ? 'Play' : 'Pause';
      }
      disconnectedCallback() { this.paceObserver?.disconnect(); this.abort?.abort(); this.abort = null; }
    }
    customElements.define('sfs-announcements', SfsAnnouncements);
  }
  if (!customElements.get('sfs-catalog')) {
    class SfsCatalog extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.cards = [...this.querySelectorAll('[data-product]')];
        this.buttons = [...this.querySelectorAll('[data-filter]')];
        this.buttons.forEach(button => {
          const count = this.cards.filter(card => button.dataset.filter === 'all' || card.dataset.group === button.dataset.filter).length;
          button.querySelector('[data-filter-count]').textContent = count;
          button.addEventListener('click', () => this.filter(button.dataset.filter), { signal: this.abort.signal });
        });
        this.querySelector('[data-toolbar]').hidden = false;
        this.filter('all');
      }
      filter(group) {
        let visible = 0;
        this.cards.forEach(card => { card.hidden = group !== 'all' && card.dataset.group !== group; if (!card.hidden) visible++; });
        this.buttons.forEach(button => { const active = button.dataset.filter === group; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
        this.querySelector('[data-results]').textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
        this.querySelector('[data-empty]').hidden = visible > 0;
      }
      disconnectedCallback() { this.paceObserver?.disconnect(); this.abort?.abort(); this.abort = null; }
    }
    customElements.define('sfs-catalog', SfsCatalog);
  }
})();
